@if (options) {
    @defer (on viewport) {
        <div class="z-10 size-full" leaflet [leafletOptions]="options"></div>
    } @placeholder {
        <div class="size-full"></div>
    }
}
